/* eslint-disable jsx-a11y/anchor-is-valid */
import {FormikValues} from 'formik'

const AddPropertyStep4 = ({formik}: FormikValues) => {
  return (
    <div data-kt-stepper-element='content'>
      <div className='w-100 py-5 mb-10'>
        {/*Begin::Form Group Furnishing Type*/}
        <div className='fv-row'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Furnishing Type</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Choose furnishing type'
            ></i>
          </label>
          <select
            className='form-select form-select-solid'
            name='property_furnishing_status'
            placeholder='Select furnishing type'
            {...formik.getFieldProps('property_furnishing_status')}
          >
            <option className='bg-color-gray' value='' disabled>
              Select furnishing type
            </option>
            <option value='1'>Unfurnished</option>
            <option value='2'>Semi Furnished</option>
            <option value='3'>Fully Furnished</option>
          </select>
          <div className='h-20px'>
            {formik.touched.property_furnishing_status &&
              formik.errors.property_furnishing_status && (
                <div className='fv-help-block color-red'>
                  {formik.errors.property_furnishing_status}
                </div>
              )}
          </div>
        </div>
        {/*End::Form Group Furnishing Type*/}
        {/*Begin::Form Group Category*/}
        <div className='fv-row'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Category</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter property category'
            ></i>
          </label>
          <div className='d-flex w-100'>
            {/*Begin:Option Residential*/}
            <label className='d-flex w-50 me-5 flex-basis-50 align-items-center justify-content-between cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='symbol-label bg-light-primary'>
                    <i className='bi bi-house-door fs-2x'></i>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>Residential</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('property_usage_type')}
                  name='property_usage_type'
                  type='radio'
                  value='1'
                  id='property_usage_type'
                />
              </span>
            </label>
            {/*End::Option Residential*/}

            {/*Begin:Option Commercial*/}
            <label className='d-flex w-50 flex-basis-50 align-items-center justify-content-between cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='symbol-label bg-light-danger'>
                    <i className='bi bi-building fs-2x'></i>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>Commercial</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('property_usage_type')}
                  name='property_usage_type'
                  type='radio'
                  value='2'
                  id='property_usage_type'
                />
              </span>
            </label>
            {/*End::Option Commercial*/}
          </div>
          <div className='h-20px'>
            {formik.touched.property_usage_type && formik.errors.property_usage_type && (
              <div className='fv-help-block color-red'>{formik.errors.property_usage_type}</div>
            )}
          </div>
        </div>
        {/*End::Form Group Category*/}
        {/*Begin::Form Group Subdivisions*/}
        <div className='fv-row'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Subdivisions</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Select whether property have subdivisions'
            ></i>
          </label>
          <div className='d-flex w-100'>
            {/*Begin:Option */}
            <label className='d-flex w-50 me-5 flex-basis-50 align-items-center justify-content-between cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='symbol-label bg-light-primary'>
                    <i className='bi bi-check-square fs-2x'></i>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>Yes</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('sub_unit_available')}
                  name='sub_unit_available'
                  type='radio'
                  value='true'
                  id='sub_unit_available'
                />
              </span>
            </label>
            {/*End::Option */}

            {/*Begin:Option */}
            <label className='d-flex w-50 flex-basis-50 align-items-center justify-content-between cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='symbol symbol-50px me-2'>
                  <span className='symbol-label bg-light-danger'>
                    <i className='bi bi-x-square fs-2x'></i>
                  </span>
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder fs-6'>No</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  {...formik.getFieldProps('sub_unit_available')}
                  name='sub_unit_available'
                  type='radio'
                  value='false'
                  id='sub_unit_available'
                />
              </span>
            </label>
            {/*End::Option */}
          </div>
          <div className='h-20px'>
            {formik.touched.sub_unit_available && formik.errors.sub_unit_available && (
              <div className='fv-help-block color-red'>{formik.errors.sub_unit_available}</div>
            )}
          </div>
        </div>
        {/*End::Form Group Subdivisions*/}
      </div>
    </div>
  )
}

export default AddPropertyStep4
